import React from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';

const EllipsisGroup = ({
  id,
  expanded,
  handleAccordionChange,
  color,
  visitId,
  orderId,
}) => {
  const classes = useStyles();
  const className =
    color === 'orange'
      ? clsx(classes.expandCircle, classes.orangeCircle)
      : clsx(classes.expandCircle, classes.grayCircle);

  return (
    <div
      onClick={handleAccordionChange({ panelId: id, visitId, orderId })}
      style={{
        display: expanded && color === 'orange' ? 'none' : 'flex',
        padding: expanded ? '5px 0 20px' : '5px 0',
      }}
      className={classes.expandedCircleGroup}
    >
      {['circle1', 'circle2', 'circle3'].map(item => (
        <div key={item} className={className} />
      ))}
    </div>
  );
};

export default EllipsisGroup;
